import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { LoginAdmin } from "../../pages/Admin";
import { TopMenu, SideMenu, IssuedDocumentModal } from "../../components/Admin";
import { useAuth } from "../../hooks";
import { BASE_API } from "../../utils/constants";
import "./AdminLayout.scss";

// Al entrar al sistema (login o abrir la app), el Admin/Súper Usuario
// arranca en el Panel del día; el Estándar sigue en Pedidos. Solo la primera
// vez por sesión: después, "Pedidos" del menú lleva a /admin como siempre.
let landingChecked = false;

export function AdminLayout(props) {
  const { children } = props;
  const { auth } = useAuth();
  // Menú lateral oculto por defecto, se abre con ☰ (opción B, inspirada en
  // Restaurant.pe): así el contenido usa todo el ancho, también en el
  // celular del mozo.
  const [menuOpen, setMenuOpen] = useState(false);
  const history = useHistory();
  const { pathname } = useLocation();

  useEffect(() => {
    if (!auth) {
      landingChecked = false;
      return;
    }
    if (landingChecked) return;
    landingChecked = true;
    if (auth.me?.is_staff && pathname === "/admin") history.replace("/admin/dashboard");
  }, [auth]);

  // Instalar la app desde el Admin la instala como "<negocio> (Admin)", que
  // abre en /admin — no en la pantalla de mesa del comensal (ver
  // siteconfig/api/views.py → manifest_view).
  useEffect(() => {
    const link = document.querySelector('link[rel="manifest"]');
    if (!link) return;
    const clientHref = link.getAttribute("href");
    link.setAttribute("href", `${BASE_API}/api/site-config/manifest/?start=/admin`);
    return () => link.setAttribute("href", clientHref);
  }, []);

  if (!auth) return <LoginAdmin />;

  return (
    <div className="admin-layout">
      <div className="admin-layout__menu">
        <TopMenu onToggleMenu={() => setMenuOpen((prev) => !prev)} />
      </div>

      <div className="admin-layout__main-content">
        <SideMenu open={menuOpen} onClose={() => setMenuOpen(false)}>
          {children}
        </SideMenu>
      </div>

      {/* "Comprobante emitido": vive aquí (siempre montado) y no en el panel de
          cobro, que se cierra solo cuando la cuenta ya está pagada. */}
      <IssuedDocumentModal />
    </div>
  );
}
